// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2945":"67a42924","6582":"fe6d98cb","8420":"c9837a53","8591":"67a42924"}[chunkId] + ".chunk.css";
};